<template>
  <!-- Der Platzhalter im Grid. Hält die Struktur stabil -->
  <div
    class="tile-placeholder"
    :class="{ 'is-hovered': isHovered }"
    :style="{ height: defaultWidth + 'px', width: computedWidth + 'px' }"
    @mouseenter="handleEnter"
    @mouseleave="handleLeave"
  >
    <!-- Ladezustand wenn noch gar kein Item existiert -->
    <div v-if="!item" class="resContainer nopic-container d-flex align-center justify-center h-100 w-100">
      <v-progress-circular :size="defaultWidth/2" indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else
        class="tile-card"
        :class="{
         'is-hovered': isHovered,
         'text-only-card': noPicAvailable,
         ['info-pos-' + infoPosition]: isHovered
          }"
          :style="{ width: computedWidth + 'px', height: defaultWidth + 'px' }" >
      <template v-if="!noPicAvailable">

        <div v-if="hasInfo" class="image-section" :style="{ width: computedWidth + 'px' }">
<div v-if="item.label" class="top-label" :class="{ 'fade-out': isHovered }">
  <div class="font-weight-bold text-caption" v-html="item.label"></div>
</div>
          <div v-if="loading" class="loading-container">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div :id="imgViewerName" ref="viewer" class="osd-viewer" @click="handleClick"></div>

          <div
            v-if="isTouchDevice"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
            class="touch-overlay">
          </div>
<div class="base-label" :class="{ 'fade-out': isHovered }">
  <div class="base-label-content">
    <div
      class="base-label-title font-weight-bold text-subtitle-2"
      v-html="item.subTitle? item.subTitle: ''"
    ></div>

    <div v-if="hasInfo" class="info-hint">
      <span class="info-icon">i</span>
      <span class="info-arrow">›</span>
    </div>
  </div>
</div>
       </div>

        <div v-if="hasInfo" class="info-section">
          <div class="info-content">
            <a :href="buildLink()" target="_blank" class="text-decoration-none black--text">
              <h3 class="text-h6 mb-1 font-weight-bold" v-html="item.label" style="line-height: 1.2;"></h3>
            </a>
            <v-divider class="mb-2"></v-divider>
            <div v-if="item.subTitle" class="text-subtitle-2 grey--text text--darken-2 mb-3" v-html="item.subTitle"></div>
            <div v-if="item.highlight" class="text-body-2">
              <div v-html="item.highlight"></div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="text-primary-section pa-4 d-flex flex-column align-center justify-center text-center"
             :style="{ width: computedWidth + 'px' }"
             @click="handleClick">
           <a :href="buildLink()" target="_blank" class="text-decoration-none black--text">
             <h3 class="text-h6 mb-2 font-weight-bold" v-html="item.label" style="line-height: 1.2;"></h3>
           </a>
           <div v-if="item.subTitle" class="text-subtitle-2 grey--text text--darken-2" v-html="item.subTitle"></div>
<div v-if="hasInfo" class="info-hint-nopic">
             <span class="info-icon-dark">i</span>
             <span class="info-arrow-dark">›</span>
           </div>
          </div>
        <div v-if="hasInfo" class="info-section">
          <div class="info-content">
            <div v-if="item.highlight" class="highlight-wrapper text-body-2">
              <div v-html="item.highlight"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getOSDURL, getOSDURLCave, isMobile } from "../utils/helpers";
const OpenSeadragon = window.OpenSeadragon;
const Annotorious = window.Annotorious;

export default {
  props: {
    item: Object,
    permanentOverlay: { type: Boolean, default: false }
  },
  data() {
    return {
      isHovered: false,
      defaultWidth: 300,
      computedWidth: 300,
      viewerImg: null,
      annotoriousplugin: null,
      noPicAvailable: false,
      loading: true,
      touchStartY: 0,
      touchStartX: 0,
      touchMoved: false,
      moveThreshold: 10,
      infoPosition: 'right'
    };
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    imgViewerName() {
      if (!this.item) return '';
      return "tile-" + this.item.itemType + "-" + this.item.itemID;
    },
    isTouchDevice() {
      return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
    },
    hasInfo() {
      if (!this.item) return false;

      const subTitle = this.item.subTitle?.trim();
      const highlight = this.item.highlight?.trim();

      return !!(subTitle || highlight);
    },
  },
  methods: {
getTileStyle() {
  const baseWidth = this.noPicAvailable ? this.defaultWidth : this.computedWidth;
  return {
    height: this.defaultWidth + 'px',
    width: baseWidth + 'px' // Bleibt immer konstant!
  };
},
handleEnter() {
  this.hoverTimeout = setTimeout(() => {

    this.isHovered = true;

    if (!this.hasInfo) {
      return;
    }

    const rect = this.$el.getBoundingClientRect();
    const infoWidth = 300;

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= infoWidth) {
      this.infoPosition = 'right';
    } else if (spaceLeft >= infoWidth) {
      this.infoPosition = 'left';
    } else {
      this.infoPosition = 'overlay';
    }

  }, 100);
},
handleLeave() {
  clearTimeout(this.hoverTimeout);
  this.isHovered = false;
  this.infoPosition = 'right'; // Zurücksetzen für das nächste Mal
},
    handleTouchStart(event) {
      const touch = event.touches[0];
      this.touchStartY = touch.clientY;
      this.touchStartX = touch.clientX;
      this.touchMoved = false;
    },
    handleTouchMove(event) {
      const touch = event.touches[0];
      if (Math.abs(touch.clientY - this.touchStartY) > this.moveThreshold || Math.abs(touch.clientX - this.touchStartX) > this.moveThreshold) {
        this.touchMoved = true;
      }
    },
    handleTouchEnd() {
      if (this.touchMoved) return;

      if (!this.isHovered) {
        this.isHovered = true;

        clearTimeout(this.touchTimeout);
        this.touchTimeout = setTimeout(() => {
          this.isHovered = false;
        }, 4000);

      } else {
        clearTimeout(this.touchTimeout);
        window.open(this.buildLink(), '_blank');
      }
    },

    handleClick(event) {
      if (event && event.pointerType === "touch") return;
      window.open(this.buildLink(), '_blank');
    },
    buildLink() {
      if (this.item.link) return this.item.link;
      let link = "/" + this.item.itemType + "/" + this.item.itemID;
      return link;
    }
  },

  mounted() {
    this.$log.debug("tile mounted", this.item);
    if (isMobile()) {
      this.isHovered = false;
      this.infoPosition = 'overlay';
    }
    if (!this.item) return;

    if (this.item.itemType === "bibliography") {
      this.computedWidth = (window.screen.width < 500) ? window.screen.width : 500;
    }
    const availableWidth = this.$el.parentElement
      ? this.$el.parentElement.clientWidth
      : window.innerWidth;

    this.computedWidth = Math.min(
      this.defaultWidth,
      availableWidth
    );

    if (this.item.masterImage && Object.keys(this.item.masterImage).length > 0 && ((this.item.masterImage.accessLevel === 2) || (this.$store.state.user.sessionID && this.item.masterImage.accessLevel > 0)) ) {
      let tilesImg
      if (this.item.itemType === "pr" || this.item.itemType === "iconography") {
        tilesImg = getOSDURL(this.item.masterImage)
      } else if (this.item.itemType === "cave") {
        tilesImg = getOSDURLCave(this.item.masterImage)
      }

     this.$log.debug("initiate openseadragon", tilesImg, this.imgViewerName);
      this.viewerImg = OpenSeadragon({
        id: this.imgViewerName,
        prefixUrl: '/static/',
        tileSources: tilesImg,
        showNavigationControl: false,
        showNavigator: false,
        showZoomControl: false,
        mouseNavEnabled: false,
        handleGesture: true,
        zoomPerScroll: false,
        minZoomLevel: 1,
        defaultZoomLevel: 1,
        ...(this.user.sessionID && this.user.sessionID !== "" && {
            ajaxWithCredentials: true,
            loadTilesWithAjax: true,
            tileRequestHeaders: { "Authorization": `Bearer ${this.user.sessionID}` },
            ajaxHeaders: { "Authorization": `Bearer ${this.user.sessionID}` }
          })
      })

      this.viewerImg.addHandler("open", () => {
        const tileSource = this.viewerImg.world.getItemAt(0).source;
        const aspectRatio = tileSource.width / tileSource.height;
        const maxWidth = this.$el.parentElement.offsetWidth * 0.98
        let width = this.defaultWidth * aspectRatio;

        if (width > maxWidth) {
          width = maxWidth;
          this.defaultWidth = width / aspectRatio;
          if (this.defaultWidth < 150) this.defaultWidth = 150;
        }
        this.computedWidth = width;
        this.loading = false;
      });

      this.viewerImg.addHandler("tile-load-failed", () => { this.noPicAvailable = true; this.loading = false; });
      this.viewerImg.addHandler("open-failed", () => { this.noPicAvailable = true; this.loading = false; });
      if (this.item &&this.item?.preSelected?.length > 0){
        var MyHighlightFormatter = function(annotation) {
          if (annotation.motivation === "highlight"){
            return {
              'style': 'stroke-width:0px;stroke: gold;  fill: rgba(0, 128, 0,0.25);vector-effect: none;'
            }
          } else {
            return {
              'style': 'stroke-width:0px!important;  fill: rgba(0, 128, 0,0);vector-effect: none;'
            }
          }
        }

        const _self = this

        var config = {};
        config["readOnly"] = true;
        config["widgets"] = ['COMMENT', { widget: 'TAG', vocabulary: [], showDelete: false }]
        config["image"] = this.viewerAnnos;
        config["formatters"] = [MyHighlightFormatter];
        this.annotoriousplugin = window.OpenSeadragon.Annotorious(this.viewerImg, config)
        Annotorious.SelectorPack(this.annotoriousplugin);
        this.annotoriousplugin.disableEditor = true
        if (this.item?.preSelected?.length > 0 && this.item?.preSelected[0] !== undefined){
          this.$log.debug("loading preSelected annotations", this.item.preSelected)
          this.annotoriousplugin.setAnnotations(this.item.preSelected)
        }
      } else {
      }
    } else {
      this.noPicAvailable = true;
      this.loading = false;
    }
  }
};
</script>

<style scoped>
/*
 * 1. PLATZHALTER
 */
.tile-placeholder {
  position: relative;
  display: inline-block;
  overflow: visible; /* WICHTIG: Erlaube das Ausklappen */
  z-index: 1;
}

.tile-placeholder.is-hovered {
  z-index: 1000;
}

/*
 * 2. DIE KARTE
 */
.tile-card {
  position: absolute; /* Löst sich aus dem Grid-Fluss */
  top: 0;
  left: 0;
  display: flex;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: visible;
  transition: all 0.3s ease;
  z-index: 10;
}
.tile-card.info-right {
  /* normale Erweiterung nach rechts */
}

.tile-card.info-left .info-section {
  position: absolute;
  right: 100%;
  top: 0;
}

.tile-card.info-overlay .info-section {
  position: absolute;
  left: 0;
  top: 0;
  width: min(300px, 100%);
  height: 100%;
}
.tile-card.is-hovered {
  z-index: 9999;
  transform: scale(1.05);
  box-shadow: 0 20px 40px rgba(0,0,0,0.4);
}
.tile-card.is-hovered .info-section {
  opacity: 1;
  visibility: visible;
  z-index: 5;
}
.tile-card.info-pos-right.is-hovered .info-section { left: 100%; }
/* Links */
.tile-card.info-pos-left.is-hovered .info-section { right: 100%; left: auto; }
/* Overlay */
.tile-card.info-pos-overlay.is-hovered .info-section { left: 0; width: 100%; z-index: 20; }
/* Spezialbehandlung für Karten ohne Bild */
.tile-card.text-only-card {
  border: 1px solid #e0e0e0;
  background-color: #fafafa;
  cursor: pointer;
}
.tile-card.text-only-card:hover {
  background-color: #ffffff;
}

/* --- LINKER BEREICH (Das Bild) --- */
.image-section {
  position: relative;
  flex-shrink: 0;
  height: 100%;
  background-color: #f5f5f5;
}

.osd-viewer {
  width: 100%;
  height: 100%;
}

.h-100 { height: 100%; }
.w-100 { width: 100%; }
.top-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 60%, transparent 100%);
  color: white;
  padding: 10px 12px 20px 12px;
  z-index: 2;
  pointer-events: none;
}
.top-label.fade-out {
  opacity: 0; /* Lässt das Label beim Hovern verschwinden */
}
.top-label > div {
  overflow-wrap: break-word;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Erlaubt bis zu 2 Zeilen Umbruch, danach sanfter Schnitt */
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.base-label {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%);
  color: white;
  padding: 20px 5px 10px 12px;
  transition: opacity 0.2s ease;
  pointer-events: none;
}
.base-label.fade-out {
  opacity: 0;
}

/* --- RECHTER BEREICH (Die Schublade) --- */
.info-section {
  position: absolute;
  top: 0;
  width: 300px;
  height: 100%;
  background-color: white;
  border: 1px solid #e0e0e0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  z-index: -1;
}



.info-content, .text-only-section {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.info-content {
  padding: 16px;
  height: 100%;
}
/* --- ZUSTÄNDE FÜR DAS INFO-PANEL --- */

/* 1. Standard (info-pos-right): Info rechts angedockt */
.tile-card.info-pos-right {
  flex-direction: row;
}

/* 2. Info links (info-pos-left): Schublade klappt nach LINKS aus */
.tile-card.info-pos-left {
  flex-direction: row-reverse; /* Info-Bereich links, Bild rechts */
  left: auto;                  /* Wir lösen die absolute left-Position */
  right: 0;                    /* Wir verankern die Kachel am rechten Rand */
  transform-origin: right center; /* Zoomt von rechts */
}
.tile-card.info-pos-left .info-section {
  border-left: none;
  border-right: 1px solid #e0e0e0;
}

/* 3. Overlay (info-pos-overlay): Info legt sich ÜBER das Bild */
.tile-card.info-pos-overlay .info-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95); /* Leicht transparent */
  z-index: 20;
}
/* --- TEXT ONLY KARTE --- */
.text-primary-section {
  position: relative;
  flex-shrink: 0;
  height: 100%;
  background-color: #fafafa;
  cursor: pointer;
}
.info-hint-nopic {
  position: absolute;
  bottom: 8px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tile-card:hover .info-hint-nopic {
  opacity: 1;
  transform: translateX(3px);
}

.info-icon-dark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  font-size: 11px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1;
}

.info-arrow-dark {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 1;
}
.text-primary-section:hover {
  background-color: #ffffff;
}

.type-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}

/* Text & Highlights */
h3 {
  font-size: 1.1rem !important;
}

.highlight-wrapper {
  background-color: #fff9e6;
  padding: 12px;
  border-radius: 4px;
  border-left: 3px solid #fbc02d;
  box-shadow: inset 0 0 4px rgba(0,0,0,0.05);
}

:deep(.highlight), :deep(em) {
  background-color: #ffe082 !important;
  color: #000 !important;
  font-weight: bold;
  padding: 0 2px;
  border-radius: 2px;
}

.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.base-label-content {
  display: flex;
  align-items: flex-end; /* Zwingt beide Elemente auf die untere Grundlinie */
  justify-content: space-between; /* Titel links, Pfeil ganz rechts */
  gap: 12px;
  width: 100%;
}

.base-label-content > .font-weight-bold {
  flex: 1 1 auto;
  min-width: 0;



}
.base-label-title {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: break-word;
}
.info-hint {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  opacity: 0.75;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 19px;
  height: 19px;

  border: 1px solid rgba(255,255,255,0.8);
  border-radius: 50%;

  font-size: 12px;
  font-weight: bold;
  line-height: 1;
}

.info-arrow {
  font-size: 22px;
  line-height: 1;
}
.tile-card:hover .info-hint {
  opacity: 1;
  transform: translateX(3px);
}
.touch-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: transparent;
}
@media (max-width: 600px) {

  .tile-placeholder {
    max-width: 100%;
    overflow: visible;
  }

  .tile-card {
    max-width: 100vw;
    transform: none !important;
  }

  .tile-card.is-hovered {
    transform: none !important;
  }

  /* Informationsbereich liegt über dem Bild */
  .tile-card.info-pos-overlay .info-section {
    left: 0;
    right: auto;
    width: 100%;
    max-width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  .info-content {
    padding: 12px;
    overflow-y: auto;
    max-height: 100%;
  }

}
</style>